module.exports = __webpack_public_path__ + "img/more.0b480ffe.png";